import styled from 'styled-components';
import { Text } from '../../../../ToolkitV2/Text/Text';
import { ShieldCheckmark2Ic } from '@dsch/dd-icons';

export const DealerTitleContainer = styled(Text)`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARK};
`;

export const TrustedBadge = styled(ShieldCheckmark2Ic)`
  margin-right: ${({ theme }) => theme.spacing.S4};
  flex-shrink: 0;
`;

export const Divider = styled.div`
  flex-shrink: 0;
  width: ${({ theme }) => theme.spacing.S4};
  height: ${({ theme }) => theme.spacing.S4};
  background: ${({ theme }) => theme.donedeal.colors.GREY_DARK};
  margin-left: ${({ theme }) => theme.spacing.S8};
  margin-right: ${({ theme }) => theme.spacing.S8};
  border-radius: 50%;
`;

export const DealerTitleText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
`;

export const Established = styled.div`
  white-space: nowrap;
  flex-shrink: 0;
`;
